import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UIIcon from 'UIComponents/icon/UIIcon';
import withUsageTracking from 'editor-components/hoc/withUsageTracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const STYLE_OBJ = {
  lineHeight: '1em'
};
const EPUndoRedoButtons = ({
  buttonGroupClassName,
  buttonSize = 'small',
  buttonUse = 'tertiary',
  canRedo = false,
  canUndo = false,
  disabled = false,
  onUndo,
  onRedo,
  onTrackUsage,
  tooltipPlacement,
  buttonStyleOverride
}) => {
  function handleUndoClick() {
    onUndo();
    onTrackUsage('undo click');
  }
  function handleRedoClick() {
    onRedo();
    onTrackUsage('redo click');
  }
  return /*#__PURE__*/_jsxs(UIButtonGroup, {
    "data-test-id": "undo-redo-buttons",
    className: buttonGroupClassName,
    children: [/*#__PURE__*/_jsx(UIIconButton, {
      "data-action": "undo",
      disabled: !canUndo || disabled,
      size: buttonSize,
      onClick: handleUndoClick,
      placement: tooltipPlacement,
      tooltip: !disabled && /*#__PURE__*/_jsx(FormattedMessage, {
        message: canUndo ? 'epUndoRedoButtons.canUndo' : 'epUndoRedoButtons.cannotUndo'
      }),
      use: buttonUse,
      style: buttonStyleOverride || STYLE_OBJ,
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "undo"
      })
    }), /*#__PURE__*/_jsx(UIIconButton, {
      "data-action": "redo",
      disabled: !canRedo || disabled,
      size: buttonSize,
      onClick: handleRedoClick,
      placement: tooltipPlacement,
      tooltip: !disabled && /*#__PURE__*/_jsx(FormattedMessage, {
        message: canRedo ? 'epUndoRedoButtons.canRedo' : 'epUndoRedoButtons.cannotRedo'
      }),
      use: buttonUse,
      style: buttonStyleOverride || STYLE_OBJ,
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "redo"
      })
    })]
  });
};
EPUndoRedoButtons.propTypes = {
  buttonGroupClassName: PropTypes.string,
  buttonSize: PropTypes.string,
  buttonUse: PropTypes.string,
  canUndo: PropTypes.bool.isRequired,
  canRedo: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onUndo: PropTypes.func.isRequired,
  onRedo: PropTypes.func.isRequired,
  onTrackUsage: PropTypes.func.isRequired,
  tooltipPlacement: PropTypes.string
};
export default withUsageTracking(EPUndoRedoButtons);